import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';
import { getLastSync, startSync } from './actions';
import { JamfSyncState } from './types';

export const setProcessingReducer = (
  state: WritableDraft<JamfSyncState>,
  action: PayloadAction<boolean>
) => {
  state.processing = action.payload;
};

export const getLastSyncPendingReducer = (state: WritableDraft<JamfSyncState>) => {
  state.loadingState = 'pending';
  state.getLastSyncLoading = 'pending';
};

export const getLastSyncFulfilledReducer = (
  state: WritableDraft<JamfSyncState>,
  action: ReturnType<typeof getLastSync.fulfilled>
) => {
  const { runId, initialized, stats, createdAt, processing } = action.payload;
  state.runId = runId;
  state.initialized = initialized;
  state.stats = stats;
  state.createdAt = createdAt;
  state.processing = processing;
  state.loadingState = 'fulfilled';
  state.getLastSyncLoading = 'fulfilled';
};

export const getLastSyncRejectedReducer = (state: WritableDraft<JamfSyncState>) => {
  state.loadingState = 'rejected';
  state.getLastSyncLoading = 'rejected';
};

export const startSyncPendingReducer = (state: WritableDraft<JamfSyncState>) => {
  state.processing = true;
  state.loadingState = 'pending';
};

export const startSyncFulfilledReducer = (
  state: WritableDraft<JamfSyncState>,
  action: ReturnType<typeof startSync.fulfilled>
) => {
  const { runId, initialized, stats, createdAt, processing } = action.payload;
  state.runId = runId;
  state.initialized = initialized;
  state.stats = stats;
  state.createdAt = createdAt;
  state.processing = processing;
  state.loadingState = 'fulfilled';
};

export const startSyncRejectedReducer = (state: WritableDraft<JamfSyncState>) => {
  state.processing = false;
  state.loadingState = 'rejected';
}; 
